import {Component, OnInit} from '@angular/core';
import {PageService} from '../../services/page.service';
import {UsuarioBc} from '../../model/usuario-bc';
import {SolicitacoesService} from '../../services/solicitacoes.service';
import {AuthService} from '../../services/auth.service';
import * as moment from 'moment';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-permissoes',
  templateUrl: './permissoes.component.html',
  styleUrls: ['./permissoes.component.scss']
})
export class PermissoesComponent implements OnInit {

  config: any;
  usuarioLogado: UsuarioBc;
  solicitacoes: Array<any> = [];
  solicitacoesRespostas: Array<any> = [];
  carregando = true;

  constructor(
    private pageService: PageService,
    private solicitacoesService: SolicitacoesService,
    private authService: AuthService,
    private toast: ToastrService,
  ) { }

  async ngOnInit() {
    await this.carregarDados();
  }

  private async carregarDados() {
    console.log('tentando carregar os dados -- Permissoes');
    try {
      this.config = await this.pageService.get('paginaPrincipal');
      this.usuarioLogado = this.authService.getUsuarioLogado();
      const cpfSemFormatacao = this.usuarioLogado.cpf.trim().replace(/\D/gi, '');
      this.solicitacoes = await this.solicitacoesService.getSolicitacoesByUsuario(cpfSemFormatacao).toPromise();
      this.solicitacoes = this.solicitacoes.filter((s) => {
        return s.portfolioSolicitado !== null;
      });
      this.solicitacoes.forEach((s: any) => {
        let qtdOperacoes = 0;
        let qtdOperacoesAprovadas = 0;
        let qtdOperacoesReprovadas = 0;
        if (s.portfolioSolicitado.sgPortfolio === 'PNI' || s.portfolioSolicitado.sgPortfolio === 'Novo PNI') {
          s.imagem = './assets/images/logotipos/sipni.png';
        } else if (s.portfolioSolicitado.sgPortfolio === 'RNDS') {
          s.imagem = './assets/images/logotipos/rnds.png';
        } else if (s.portfolioSolicitado.sgPortfolio === 'CNS') {
          s.imagem = './assets/images/logotipos/cnes.png';
        } else if (s.portfolioSolicitado.sgPortfolio === 'SISCAN') {
          s.imagem = './assets/images/logotipos/bnafar.png';
        } else if (s.portfolioSolicitado.sgPortfolio === 'BNAFAR') {
          s.imagem = './assets/images/logotipos/bnafar.png';
        } else if (s.portfolioSolicitado.sgPortfolio === 'e-SUSVE') {
          s.imagem = './assets/images/logotipos/sipni.png';
        }
        for (let i = 0; i < s.portfolioSolicitado.servicos.length; i ++) {
          qtdOperacoes = qtdOperacoes + s.portfolioSolicitado.servicos[i].operacaoSolicitadas.length;
          for (let y = 0; y < s.portfolioSolicitado.servicos[i].operacaoSolicitadas.length; y ++) {
            if (s.portfolioSolicitado.servicos[i].operacaoSolicitadas[y].stAprovado === 'S') {
              qtdOperacoesAprovadas = qtdOperacoesAprovadas + 1;
            } else {
              qtdOperacoesReprovadas = qtdOperacoesReprovadas + 1;
            }
          }
        }
        s.qtdOperacoes = qtdOperacoes;
        s.qtdOperacoesAprovadas = qtdOperacoesAprovadas;
        s.qtdOperacoesReprovadas = qtdOperacoesReprovadas;
        s.dataAceiteFormatada = s.solicitacao.dtAceite !== null ? moment(s.solicitacao.dtAceite).format('DD/MM/YYYY') : '-';
        s.dataEnvioFormatada = s.solicitacao.dtEnvio !== null ? moment(s.solicitacao.dtEnvio).format('DD/MM/YYYY') : '-';
      });
      this.solicitacoesRespostas = this.solicitacoes.filter((s: any) => {
        return s.solicitacao.stSolicitacao === 'DEFERIDA_PARCIALMENTE'
          || s.solicitacao.stSolicitacao === 'TESTANDO_HOMOLOG'
          || s.solicitacao.stSolicitacao === 'TESTANDO_PRODUC'
          || s.solicitacao.stSolicitacao === 'INDEFERIDA';
      });
      this.carregando = false;
    } catch ( e ) {
      console.log(e);
      this.solicitacoesRespostas = [];
      this.toast.error('Ocorreu um erro ao buscar as permissões');
      this.carregando = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/permissoes/permissoes.component.ts